import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import styled from 'styled-components/macro';
import { DiscountItem } from '../../../../types/receipts';
import { formatMoney } from '../../../../helpers/formatters';

interface DiscountProps extends WithTranslation {
    discount: DiscountItem;
    currency?: string;
}

const Discount = (
    {
        discount,
        i18n,
        t,
        currency,
    }: DiscountProps
) => {
    const lng = i18n.language;
    return (
        <DiscountFlex>
            <DiscountItemContainer>
                <DiscountItemHeader>{t('customers.customer.receipt.fields.amount')}</DiscountItemHeader>
                {discount.amount && currency ? formatMoney(lng, discount.amount, currency) : 'N/A'}
            </DiscountItemContainer>

            <DiscountItemContainer>
                <DiscountItemHeader>{t('customers.customer.receipt.fields.discount_type')}</DiscountItemHeader>
                {discount.discount_type}
            </DiscountItemContainer>

            <DiscountItemContainer>
                <DiscountItemHeader>{t('customers.customer.receipt.fields.discount_id')}</DiscountItemHeader>
                {discount.discount_id}
            </DiscountItemContainer>
        </DiscountFlex>
    );
};

const DiscountFlex = styled.div`
    display: flex;
`;

const DiscountItemHeader = styled.h3`
    font-size: 14px;
    color: #7d8a8c;
`;

const DiscountItemContainer = styled.div`
    flex: 1 0 auto;
`;

export default withTranslation()(Discount);
